<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-3">
    <div class="row mt-0">
      <div class="col-sm-12 custom-form-main-label" v-if="projectId == -1">
        {{$t('add_project')}}
      </div>
    </div>
    <div class="row mt-0" v-if="projectId != -1">
      <div class="col-sm-12 custom-form-main-label">
        {{$t('manage_project')}}
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <form id="createProjectForm" name="createProjectForm" class="login-formx form-validate" action="index.html" onsubmit="return false">
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('project_name')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <input required v-model="projectname" type="text" id="txtprojectname" v-bind:placeholder="$t('project_name')" maxlength="200" name="projectname" class="form-control" />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('description')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <textarea  v-model="description" class="form-control" name="description" v-bind:placeholder="placeholder"></textarea>
            </div>
          </div>
          <div class="form-group row mt-3">
            <div class="col-lg-12">
              <button @click="createProject" type="submit" class="btn skin primary-button pull-right"><i class="icon-cog5 mr-2"></i> {{$t('save')}}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  let message = "";
  var placeholder = "";

  export default {
    name: "add-project",
    components: {

    },
    props: {
      projectId: {
        type: Number,
        default: -1
      },
    },
    data() {
      return {
        message: "",
        projectname: "",
        description: "",
        placeholder
      };
    },
    methods: {
      clearFields() {
        this.projectname = '';
        this.description = '';
      },
      async createProject() {
        if (!$('#createProjectForm').valid())
          return false;
        var request = { ProjectId: this.projectId, Name: this.projectname, Description: this.description };

        try {
          var response = await this.$http.post(
            '/api/Projects/v1',
            request
          ).then(async response => {
            this.clearFields();
            vm.$root.$emit('refreshview');
          });

        } catch (err) {
          alert(err);
        }
      },
      async getProject(projectId) {
        try {          
          this.$http.get(`/api/Projects/v1/${projectId}`).then(async response => {
            var project = response.data;
            this.projectname = project.Name;            
            this.description = project.Description;
          });
        } catch (err) {
          alert('some error:' + err)
        }
      }
    },
    watch: {
      projectId: function (newVal, oldVal) {
        if (newVal > 0) {
          this.getProject(newVal);
        } else {
          this.projectname = '';
          this.description = '';
        }
      }
    },
    mounted() {
      _componentValidation('#createProjectForm');
      if (this.projectId > 0) {
        this.getProject(this.projectId);
      }

      this.placeholder = this.$t('project_description');
    }
  };
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/project/add-project.vue